import { Card, CardContent } from '@/components/ui/card';
import { RotateCcw, CheckCircle2, FileX, CloudOff, ArrowRight } from 'lucide-react';

const ACTIONS = [
  {
    key: 'returned',
    tab: 'returned',
    label: 'Correct & Resubmit',
    sub: 'Returned by officer',
    icon: RotateCcw,
    color: '#dc2626',
    bg: '#fef2f2',
    kpi: 'returned_cases',
  },
  {
    key: 'ready',
    tab: 'ready',
    label: 'Ready to Submit',
    sub: 'Score-ready drafts',
    icon: CheckCircle2,
    color: '#16a34a',
    bg: '#f0fdf4',
    kpi: 'ready_to_submit',
  },
  {
    key: 'missing_docs',
    tab: 'missing_docs',
    label: 'Fix Missing Documents',
    sub: 'Required KYC / land proof',
    icon: FileX,
    color: '#d97706',
    bg: '#fffbeb',
    kpi: 'missing_documents',
  },
  {
    key: 'pending_ext',
    tab: 'pending_ext',
    label: 'Refresh External Data',
    sub: 'Weather / NDVI / PM-KISAN / Soil',
    icon: CloudOff,
    color: '#7c3aed',
    bg: '#faf5ff',
    kpi: 'pending_external_refresh',
  },
];

const NextActionsStrip = ({ kpis, activeTab, onSelect }) => (
  <div className="mb-5" data-testid="agent-next-actions">
    <div className="text-xs uppercase tracking-wide font-semibold text-gray-600 mb-2 flex items-center gap-2">
      My Next Actions
      <div className="h-px flex-1 bg-gray-200" />
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
      {ACTIONS.map(a => {
        const Icon = a.icon;
        const count = kpis?.[a.kpi] ?? 0;
        const isActive = activeTab === a.tab;
        const isUrgent = a.key === 'returned' && count > 0;
        return (
          <Card
            key={a.key}
            onClick={() => onSelect(a.tab)}
            className={`cursor-pointer transition-all border-2 ${isActive ? 'shadow-md' : 'hover:shadow-sm'}`}
            style={{
              borderColor: isActive ? a.color : (isUrgent ? '#fca5a5' : '#e5e7eb'),
              background: isActive ? a.bg : 'white',
            }}
            data-testid={`next-action-${a.key}`}
          >
            <CardContent className="p-4">
              <div className="flex items-start justify-between mb-3">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: a.bg }}>
                  <Icon className="h-5 w-5" style={{ color: a.color }} />
                </div>
                <ArrowRight className="h-4 w-4 text-gray-300" />
              </div>
              <div className="flex items-baseline gap-2 mb-0.5">
                <div className="text-2xl font-bold tabular-nums" style={{ color: a.color }}>{count}</div>
                {isUrgent && <span className="text-[10px] font-semibold text-red-600 uppercase">urgent</span>}
              </div>
              <div className="text-sm font-semibold text-gray-800 leading-tight">{a.label}</div>
              <div className="text-[10px] text-gray-500 mt-0.5">{a.sub}</div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  </div>
);

export default NextActionsStrip;
